import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useSeoMeta } from '../../hooks/useSeoMeta';
import { PARTNERS_PAGE_URL } from './constants';
import PartnersNav from './sections/PartnersNav';
import PartnersHero from './sections/PartnersHero';
import PartnersStatsBar from './sections/PartnersStatsBar';
import PartnersHowItWorks from './sections/PartnersHowItWorks';
import PartnersContrast from './sections/PartnersContrast';
import PartnersFeatures from './sections/PartnersFeatures';
import PartnersExclusivity from './sections/PartnersExclusivity';
import PartnersFaq from './sections/PartnersFaq';
import PartnersFinalCta from './sections/PartnersFinalCta';
import HomeRedesignFooter from '../home-redesign/HomeRedesignFooter';
import { usePartnersStrings } from './usePartnersStrings';

const PartnersPage: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const { seo } = usePartnersStrings();

  useSeoMeta({
    title: seo.title,
    description: seo.description,
    url: PARTNERS_PAGE_URL,
    locale: currentLanguage === 'en' ? 'en' : 'es',
  });

  return (
    <div className="min-h-screen bg-[#fcf7fa] font-jakarta text-[#2a0f2a] antialiased">
      <PartnersNav />
      <main>
        <PartnersHero />
        <PartnersStatsBar />
        <PartnersHowItWorks />
        <PartnersContrast />
        <PartnersFeatures />
        <PartnersExclusivity />
        <PartnersFaq />
        <PartnersFinalCta />
      </main>
      <HomeRedesignFooter />
    </div>
  );
};

export default PartnersPage;
